import React, { useContext } from 'react'
import ClassNames from 'classnames'

import { RecommendationProvider } from 'Contexts/RecommendationContext/RecommendationContext'
import { AddToCartExperienceContext } from 'Contexts/AddToCartExperienceContext/AddToCartExperienceContext'

import RecommendationSection from 'Organisms/RecommendationSection'

import Button from 'Molecules/Button'
import Drawer from 'Molecules/Drawer'

import Typography from 'Atoms/Typography'
import TextLink from 'Atoms/TextLink'
import Panel from 'Atoms/Panel'
import Svg from 'Atoms/Svg'
import Divider from 'Atoms/Divider'

import AddToCartDrawerCartProducts from './cartProducts/cartProducts'
import styles from './addToCartDrawer.module.scss'

const AddToCartDrawer = ({ mockRecommendations }) => {

  const addToCartExperienceContext = useContext(AddToCartExperienceContext);

  const continueToCartEvent = {
    category: null,
    action: 'Add to Cart',
    label: 'Add To Cart Drawer'
  }

  const numberOfProductAddedToCart = ((addToCartExperienceContext || {}).items || []).reduce((prevQuantity, currItem) => prevQuantity + currItem.quantityRequested, 0);

  const cartTotalPrice = addToCartExperienceContext.cartTotalPrice && addToCartExperienceContext.cartTotalPrice.length ?
    addToCartExperienceContext.cartTotalPrice.trim().replace('$', '')
    : 0;

  let displayCartTotalPrice = `$${(149 - cartTotalPrice).toFixed(2)}`

  if (displayCartTotalPrice.endsWith('.00')) {
    displayCartTotalPrice = displayCartTotalPrice.replace('.00', '')
  }

  return (
    <Drawer
      portalId={'atcDrawer'}
      location={'right'}
      width={640}
      open={addToCartExperienceContext.isAtcDrawerOpen}
      closeFunction={() => addToCartExperienceContext.hideAtcDrawer()}>

      <div className={ClassNames(styles.atc_drawer)} data-testid={`atc_drawer_${addToCartExperienceContext.isAtcDrawerOpen ? 'open' : 'closed'}`}>
        <span className={styles.atc_drawer_image_wrapper}>
          <AddToCartDrawerCartProducts addToCartDrawerItems={addToCartExperienceContext.items} />
        </span>
        <Typography size={1.25} font={'bold'} className={ClassNames(styles.center, styles.atc_drawer_header)}>
          <Svg icon={'check'} intent={'positive'} size={1} className={ClassNames(styles.atc_drawer_header_icon)} />
          {`${(numberOfProductAddedToCart || 0)} ${(numberOfProductAddedToCart || 0) === 1 ? 'item' : 'items'} added to cart`}
        </Typography>
        <Divider />
        <Panel layer={0} className={ClassNames(styles.atc_drawer_panel)}>

          {addToCartExperienceContext.isAtcDrawerOpen ?
            <RecommendationProvider
              sections={["ATC_Drawer"]}
              skuBaseNumbers={(addToCartExperienceContext.items ?? []).map(product => product.skuBaseNumber)}>
              <RecommendationSection section={"ATC_Drawer"} numberOfSkeletons={3} numberOfSkeletonSections={1} skeletonDisplayType={"Vertical"} displayType={"Vertical"} spacingSize={'None'} lazyMargin={"800px"} testData={mockRecommendations} />
            </RecommendationProvider>
            :
            false
          }
        </Panel>

        <Panel layer={0} className={ClassNames(styles.atc_drawer_panel_footer)}>
          <Divider className={styles.atc_drawer_panel_footer_divider} />
          <span className={styles.atc_drawer_panel_footer_header}>
            <span>
              <Typography size={0.75}>
                {`${addToCartExperienceContext && addToCartExperienceContext.itemCount ? addToCartExperienceContext.itemCount : 0} ${addToCartExperienceContext && addToCartExperienceContext.itemCount === 1 ? 'item' : 'items'} in cart`}
              </Typography>
              <Typography size={1} tone={'contrast'}>
                Subtotal
              </Typography>
            </span>
            <Typography size={1.5} font={'bold'} tone={'contrast'} inline className={ClassNames(styles.atc_drawer_subtotal)}>
              {addToCartExperienceContext && addToCartExperienceContext.cartTotalPrice ? addToCartExperienceContext.cartTotalPrice : '$0.00'}
            </Typography>
          </span>

          <Button
            text={'View Cart'}
            intent={'positive'}
            size={'small'}
            fill
            gaEvent={continueToCartEvent}
            segmentEvent={{event: 'Clicked', properties:{element: 'View Cart Button - ATC Drawer'}}}
            href={`/shoppingcart`}
            data-testid={'atc-drawer-view-cart'} />
          <TextLink size={1} className={ClassNames(styles.center, styles.atc_drawer_continue_shopping)} onClick={addToCartExperienceContext.hideAtcDrawer} data-testid={'atc-drawer-continue-shopping'} segmentEvent={{event: 'Clicked', properties:{element: 'Continue Shopping Button - ATC Drawer'}}}>
            Continue Shopping
          </TextLink>
        </Panel>
      </div>
    </Drawer>
  )
}

export default AddToCartDrawer